import { memo } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { FiSearch } from '@react-icons/all-files/fi/FiSearch';

import { IProps } from './model';

export const SearchButton = memo<IProps>(({ handleOpenModal }) => {
  return (
    <Box
      display="flex"
      marginLeft={0.5}
      justifyContent="center"
      displayPrint="none"
    >
      <IconButton onClick={handleOpenModal} aria-label="Buscar no site">
        <FiSearch color="#fff" size={24} />
      </IconButton>
    </Box>
  );
});
